<template>
  <DialogueBox
    data-auto-id="group-delete-dialogue"
    :showing="showing"
    title="Confirm Deletion"
  >
    <div class="p-4">
      <p>Are you sure you want to remove this group?</p>
      <dl class="mb-8">
        <dt data-auto-id="group-delete-name" class="font-bold">
          {{ deleteQueue.groupName }}
        </dt>
        <dd data-auto-id="group-delete-group" class="text-tiny text-gray-dark">
          {{ deleteQueue.groupID }}
        </dd>
      </dl>
      <div class="flex items-center">
        <button
          data-auto-id="group-delete-confirm"
          @click.prevent="$emit('confirm')"
          class="m-0 mr-4"
        >
          Confirm
        </button>
        <a
          href="#!"
          @click.prevent="$emit('cancel')"
          class="text-gray-darkest no-underline"
          >Cancel</a
        >
      </div>
    </div>
  </DialogueBox>
</template>

<script>
import DialogueBox from '../../../Common/DialogueBox'
export default {
  name: 'GroupDeleteDialogue',
  components: {
    DialogueBox,
  },
  props: {
    showing: Boolean,
    deleteQueue: Object,
  },
}
</script>
